export default __webpack_public_path__ + "static/media/do-icon-white.8f80a2b4.svg";